module.exports = __webpack_public_path__ + "static/img/b2c_main_logo.636d3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2c/b2c_main_logo.png
// module id = Owc6
// module chunks = 18